module.exports = __webpack_public_path__ + "media/ChineseFestivals.aedbfbb0.mp3";